import { useEmitResourceCreatedEvents as useEmitResourceCreatedEventsObservability } from "@zapier/observability";
import { useAtomValue } from "jotai";
import {
  canvasAtom,
  currentAccountIdAtom,
  sessionAtom,
} from "@zapier/canvas-state";

export function useEmitResourceCreatedEvents() {
  const canvas = useAtomValue(canvasAtom);
  const session = useAtomValue(sessionAtom);
  const currentAccountId = useAtomValue(currentAccountIdAtom);

  return useEmitResourceCreatedEventsObservability({
    canvasId: canvas.id,
    sessionId: session?.id,
    currentAccountId: currentAccountId,
  });
}
